<app-loading *ngIf="contentReady"></app-loading>

<div class="auth-vcash-page" style="margin-bottom: 50px;">

  <!-- TOP BLACK AREA -->
  <section class="auth-top">
    <div class="auth-top__inner">
      <div class="auth-logo-pill">
        <img class="auth-brand-logo" src="/assets/e-commerce/icons/48.webp" alt="ZAZU Logo" />
      </div>

      <div class="auth-top__content">
        <span class="auth-mini-badge">{{ "welcomeinblue" | transloco }}</span>
        <h1 class="auth-top__title">
          {{ isUpdatePage ? ('Edit' | transloco) : ('Create Account' | transloco) }}
        </h1>
        <p class="auth-top__desc">{{ "retextlio" | transloco }}</p>
      </div>
    </div>
  </section>

  <!-- MAIN CONTENT -->
  <div class="auth-content">

    <!-- FORM CARD -->
    <section class="auth-card">
      <div class="auth-card__header">
        <h2 class="auth-card__title">
          {{ isUpdatePage ? ('Edit' | transloco) : ('Create Account' | transloco) }}
        </h2>
        <p class="auth-card__sub">{{ "welcomeinlio" | transloco }}</p>
      </div>

      <form [formGroup]="formInfo" (ngSubmit)="onSubmit()" class="auth-form">

        <div class="auth-two-cols">
          <div class="auth-form-group">
            <label class="auth-label">{{ 'first Name' | transloco }}</label>
            <div class="auth-input-wrap">
              <input class="auth-input" type="text" formControlName="name" [ngClass]="{
                  'is-invalid': formInfo.get('name')?.touched && formInfo.get('name')?.invalid,
                  'is-valid': formInfo.get('name')?.touched && formInfo.get('name')?.valid
                }" />
            </div>
          </div>

          <div class="auth-form-group">
            <label class="auth-label">{{ 'second Name' | transloco }}</label>
            <div class="auth-input-wrap">
              <input class="auth-input" type="text" formControlName="sname" />
            </div>
          </div>
        </div>

        <div class="auth-form-group">
          <label class="auth-label">{{ 'phone' | transloco }}</label>
          <div class="auth-input-wrap">
            <input class="auth-input" type="text" formControlName="phone" />
          </div>
        </div>

        <div class="auth-two-cols">
          <div class="auth-form-group">
            <label class="auth-label">{{ 'Password' | transloco }}</label>
            <div class="auth-input-wrap">
              <input class="auth-input" [type]="isPasswordVisible ? 'text' : 'password'" formControlName="password" />
            </div>
          </div>

          <div class="auth-form-group">
            <label class="auth-label">{{ 'Confirm Password' | transloco }}</label>
            <div class="auth-input-wrap auth-password-wrap">
              <input class="auth-input" [type]="isPasswordVisible ? 'text' : 'password'" formControlName="c_Password"
                [ngClass]="{
                  'is-invalid':
                    formInfo.get('c_Password')?.touched &&
                    formInfo.get('c_Password')?.invalid
                }" />

              <button type="button" class="auth-toggle-password" (click)="togglePasswordVisibility()">
                {{ isPasswordVisible ? ('Hide Password' | transloco) : ('Show Password' | transloco) }}
              </button>
            </div>
          </div>
        </div>

        <button type="submit" class="auth-submit-btn" [disabled]="formInfo.invalid">
          {{ isUpdatePage ? ('Edit' | transloco) : ('Create' | transloco) }}
        </button>

        <div class="auth-divider"></div>

        <div class="auth-register-box">
          <span>{{ 'alreadyuser' | transloco }}</span>
          <a routerLink="/Login">{{ 'Log in' | transloco }}</a>
        </div>
      </form>
    </section>

    <!-- QUICK BENEFITS -->
    <section class="auth-benefits">
      <div class="auth-benefits__header">
        <h3>{{ "welcomeinblue" | transloco }}</h3>
      </div>

      <div class="auth-benefits-grid">
        <div class="auth-benefit-card">
          <div class="auth-benefit-icon">
            <img class="auth-brand-logo" src="/assets/e-commerce/icons/83.webp" alt="ZAZU Logo" />
          </div>
          <span>{{ "easy" | transloco }}</span>
        </div>

        <div class="auth-benefit-card">
          <div class="auth-benefit-icon">
            <img class="auth-brand-logo" src="/assets/e-commerce/icons/85.webp" alt="ZAZU Logo" />
          </div>
          <span>{{ "fast shopping" | transloco }}</span>
        </div>

        <div class="auth-benefit-card">
          <div class="auth-benefit-icon">
            <img class="auth-brand-logo" src="/assets/e-commerce/icons/84.webp" alt="ZAZU Logo" />
          </div>
          <span>{{ "daily_offer" | transloco }}</span>
        </div>

        <div class="auth-benefit-card">
          <div class="auth-benefit-icon">
            <img class="auth-brand-logo" src="/assets/e-commerce/icons/86.webp" alt="ZAZU Logo" />
          </div>
          <span>{{ "smooth experience" | transloco }}</span>
        </div>
      </div>
    </section>

  </div>
</div>